import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import { forwardRef } from "react";

interface IconifyProps {
	icon: string;
	width?: number | string;
	sx?: any;
}

const Iconify = forwardRef(({ icon, width = 20, sx, ...other }: IconifyProps, ref) => (
	<Box ref={ref} component={Icon} icon={icon} sx={{ width, height: width, ...sx }} {...other} />
));

export default Iconify;
